import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { PAYMENT_URL } from "../lib/site";

export default function StickyCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-bar"
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-[#E9DFFC] bg-white/90 px-4 py-3 backdrop-blur-md transition-[transform,opacity] duration-300 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-full opacity-0"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="leading-tight">
          <span className="block text-[11px] font-semibold text-[#777181] line-through">₹999</span>
          <span className="block text-lg font-extrabold text-[#171321]">₹199 <span className="text-[11px] font-bold text-[#7C3AED]">80% OFF</span></span>
        </div>
        <a
          href={PAYMENT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bottom-cta-btn"
          className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#9B5CF0] via-[#7C3AED] to-[#6D28D9] px-6 py-3 text-sm font-bold text-white shadow-[0_10px_25px_-5px_rgba(124,58,237,0.5)] transition-transform duration-200 active:scale-95"
        >
          Join Now <ArrowRight size={15} strokeWidth={2.5} />
        </a>
      </div>
    </div>
  );
}
